import React from 'react';
import { motion } from 'framer-motion';
export function BureauTrustSection() {
  const bureaus = [{
    name: 'Equifax',
    id: 'equifax',
    logo: <svg viewBox="0 0 130 32" className="h-7 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-16">
          <text x="0" y="25" fontFamily="Inter, Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="28" fill="#D8232A" letterSpacing="-0.5" data-id="element-17">
            EQUIFAX
          </text>
        </svg>
  }, {
    name: 'Experian',
    id: 'experian',
    logo: <svg viewBox="0 0 140 32" className="h-7 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-18">
          <text x="0" y="25" fontFamily="Inter, Arial, sans-serif" fontWeight="800" fontSize="28" fill="#26478D" letterSpacing="-0.8" data-id="element-19">
            experian
          </text>
          <circle cx="120" cy="24" r="2.5" fill="#26478D" data-id="element-20" />
        </svg>
  }, {
    name: 'TransUnion',
    id: 'transunion',
    logo: <svg viewBox="0 0 160 36" className="h-7 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-21">
          <circle cx="16" cy="18" r="15" fill="#00A6CE" data-id="element-22" />
          <text x="6" y="24" fontFamily="Inter, Arial, sans-serif" fontWeight="700" fontSize="16" fill="white" letterSpacing="-0.5" data-id="element-23">
            tu
          </text>
          <text x="38" y="26" fontFamily="Inter, Arial, sans-serif" fontWeight="600" fontSize="22" fill="#4F4F4F" letterSpacing="-0.5" data-id="element-24">
            TransUnion
          </text>
        </svg>
  }, {
    name: 'Innovis',
    id: 'innovis',
    logo: <svg viewBox="0 0 110 32" className="h-7 w-auto" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-25">
          <text x="0" y="25" fontFamily="Inter, Arial, sans-serif" fontWeight="700" fontSize="28" fill="#003DA5" letterSpacing="-0.8" data-id="element-26">
            Innovis
          </text>
          <text x="92" y="14" fontFamily="Inter, Arial, sans-serif" fontWeight="500" fontSize="9" fill="#003DA5" data-id="element-27">
            ®
          </text>
        </svg>
  }];
  return <section className="py-20 bg-slate-50 border-y border-slate-200" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="text-center mb-10" data-id="element-30">
          <h3 className="text-sm font-bold tracking-widest text-slate-500 uppercase" data-id="element-31">
            We track tools that report to:
          </h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10" data-id="element-32">
          {bureaus.map((bureau, index) => <motion.div key={bureau.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} whileHover={{
          y: -4,
          boxShadow: '0 10px 25px -5px rgba(15, 39, 71, 0.1), 0 8px 10px -6px rgba(15, 39, 71, 0.1)'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white py-8 px-6 rounded-2xl border border-slate-200 shadow-card flex flex-col items-center justify-center transition-all duration-300" data-id="element-33">
              <div className="mb-4" data-id="element-34">{bureau.logo}</div>
              <span className="text-[10px] font-medium text-slate-400 uppercase tracking-wider" data-id="element-35">
                Major consumer bureau
              </span>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-36">
          <p className="text-slate-600 font-medium" data-id="element-37">
            Tools reporting to MORE bureaus build credit faster. Look for the{' '}
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-700 mx-1 uppercase tracking-wider" data-id="element-38">
              Best Match
            </span>{' '}
            badge above.
          </p>
        </div>
      </div>
    </section>;
}